import NativeSwitch from './NativeSwitch';

export default NativeSwitch;
